export class ApiUserDetails{
    public Id : Number;
    public ApiUserName : String;
    public ApiDescription : String;
    public ApiIpAddresses : String;
    public ApiKey : String;
    public LastApiCallDateTime: String;
}


// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/models/api.user.details.model.ts